import {
  getRequestV2,
  patchRequest,
  deleteRequestV2,
  patchRequestV2,
  postRequestV2,
} from 'utils/api/methods';

const getSheets = (shareId: string) =>
  getRequestV2(`excel/sheets?share_id=${shareId}`);

const getColumns = (sheetId: string, driveId: string, fileId: string) =>
  getRequestV2(
    `excel/cells?sheet_id=${sheetId}&drive_id=${driveId}&file_id=${fileId}`
  );

const showCell = (
  fileId: string,
  sheetId: string,
  driveId: string,
  cellName: string
) =>
  getRequestV2(
    `excel/cells/value?file_id=${fileId}&sheet_id=${sheetId}&drive_id=${driveId}&cell_name=${cellName}`
  );

const saveCell = (payload: {
  fileId: string;
  sheetId: string;
  driveId: string;
  cellName: string;
  targetId: number;
  targetType: 'KeyResult' | 'KPI';
}) => postRequestV2(`excel/cells`, payload);

const updateCell = (
  cellSyncId: number,
  payload: {
    fileId: string;
    sheetId: string;
    driveId: string;
    cellName: string;
  }
) => patchRequestV2(`excel/cells/${cellSyncId}`, payload);

const deleteCell = (cellSyncId: number) =>
  deleteRequestV2(`excel/cells/${cellSyncId}`);

const updateExcelSetting = (payload: { enabled: boolean }) =>
  patchRequest('settings/integrations/excel', payload);

const excel = {
  getSheets,
  getColumns,
  showCell,
  saveCell,
  updateCell,
  updateExcelSetting,
  deleteCell,
};

export default excel;
